import { render, staticRenderFns } from "./addressAddModel.vue?vue&type=template&id=ca9718e8&scoped=true&"
import script from "./addressAddModel.vue?vue&type=script&lang=js&"
export * from "./addressAddModel.vue?vue&type=script&lang=js&"
import style0 from "./addressAddModel.vue?vue&type=style&index=0&id=ca9718e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9718e8",
  null
  
)

export default component.exports